module.exports = __webpack_public_path__ + "static/media/25.3d816b84.png";